<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'furniturefabricscolors_new'" (ttClick)="goToFunc('furniturefabricscolor')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListColours"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-header ng-if="vm.model.setting.page_heading > ''" tt-model="vm.model.setting.page_heading"></tt-header>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button class="col-xs-12 sp-0" tt-text="furniturefabricscolors_new" tt-click="vm.goToFunc('furniturefabricscolor')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListColours" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
